import React from "react";
import GitHubIcon from "@material-ui/icons/GitHub";
import ComputerSharpIcon from "@material-ui/icons/ComputerSharp";
import "./Header.css";
import { Typewriter } from 'react-simple-typewriter';
import { Switch } from "@mui/material";

function Header() {
  return (
    <div className="top_container">
      <div className="logo_header">
        <GitHubIcon />
      </div>
      <div className="top">
        <ComputerSharpIcon />
      </div>
      
      <div className="main_name">
      <h1>Maifooz Sheikh</h1>
      <Typewriter
            words={['Frontend Developer']}
            loop
            cursor
            cursorStyle='_'
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1000}
            
          />
      </div>

      <Switch color="secondary"
        
      />
    </div>
  );
}

export default Header;
